<template>
    <header>
        <div id="above_nav">
            <div class="container">
                <router-link to="/">
                    <img src="/img/logo.png">
                </router-link>
                <div id="header_links">
                    <ul>
                        <li>
                            <form action="/toggle_disabled_mode"
                            class="d-inline"
                            id="akadalymentes-form"
                            method="post">
                                <a href="#"
                                class="akadalymentes"
                                onclick="document.getElementById('akadalymentes-form').submit();"
                                title="Akadálymentes nézet">
                                </a>
                            </form>
                        </li>
                    </ul>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <nav class="navbar navbar-expand-md navbar-dark bg-dark">
            <div class="container">
                <button class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbar_menu_top"
                aria-controls="navbar_menu_top"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onclick="toggleShowBcBootstrapWontDoIt('navbar_menu_top')">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <ul class="still_on_view nav navbar-nav">
                    <li>
                        <form action="/toggle_disabled_mode"
                        class="d-inline"
                        id="akadalymentes-form"
                        method="post">
                            <a href="#"
                            class="akadalymentes"
                            onclick="document.getElementById('akadalymentes-form').submit();"
                            title="Akadálymentes nézet">
                            </a>
                        </form>
                    </li>
                </ul>
                <div class="collapse navbar-collapse" id="navbar_menu_top">
                    <ul class="navbar-nav mr-auto">
                        <router-link class="nav-link" :to="{ path: '/page/mi-az-a-cityapp' }">
                            Mi az a Cityapp?
                        </router-link>
                        <router-link class="nav-link" :to="{ path: '/page/kozlekedesi-mobiljegy' }">
                            Közlekedési mobiljegy
                        </router-link>
                    </ul>
                </div>
            </div>
        </nav>
    </header>
</template>

<script>
export default {
    computed: {        
    }
};
</script>